export default "__VITE_ASSET__Ce4vyH$O__"